export function initDataNumbers() {
    const counters = document.querySelectorAll<HTMLElement>('[data-number]');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counter = entry.target as HTMLElement;
                const target = parseFloat(counter.dataset.number!);
                const hasDecimals = target % 1 !== 0;
                const duration = 2000; // 2 seconds
                const step = target / (duration / 16); // 60fps
                let current = 0;

                const timer = setInterval(() => {
                    current += step;
                    if (current >= target) {
                        current = target;
                        clearInterval(timer);
                    }
                    counter.textContent = hasDecimals ? current.toFixed(1) : Math.floor(current).toString();
                }, 16);

                observer.unobserve(counter);
            }
        });
    });

    counters.forEach(counter => observer.observe(counter));
}